import { LoadingSymbol, NftRedemptionsTable } from '../components';
import { useNftRedemptions } from '../hooks/useNftRedemptions';

export function GcoversPage() {
   const { nftRedemptions, loading, error } = useNftRedemptions();

   return (
      <div className="flex flex-col gap-3">
         <img
            src="/assets/images/g-covers-banner-5.png"
            alt="GolfN G Covers"
            className="g-cover-banner"
         />
         {loading ? (
            <div className="flex justify-center items-center py-12">
               <LoadingSymbol
                  dark={true}
                  size={40}
               />
            </div>
         ) : error ? (
            <div className="text-center py-8">
               <div className="">
                  <h3 className="">Error Loading GolfN G Covers</h3>
                  <p className="">{error}</p>
               </div>
            </div>
         ) : (
            <div className="">
               <NftRedemptionsTable nftRedemptions={nftRedemptions} />
            </div>
         )}
      </div>
   );
}
